/* GLOWPAW — interacciones y animaciones (vanilla, sin librerías) */
(function () {
  'use strict';
  var html = document.documentElement;
  html.classList.add('gp-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Color de luz global (lo comparten portada y producto) ---------- */
  function ponerLuz(hex, guardar) {
    if (!hex || !/^#[0-9a-f]{6}$/i.test(hex)) return;
    html.style.setProperty('--gp-luz', hex);
    if (guardar) { try { localStorage.setItem('gp-luz', hex); } catch (e) {} }
  }
  window.gpPonerLuz = ponerLuz;

  /* ---------- Titulares palabra a palabra ---------- */
  function initSplit(root) {
    (root || document).querySelectorAll('[data-gp-split]:not([data-gp-split-ok])').forEach(function (el) {
      el.setAttribute('data-gp-split-ok', '');
      var i = 0;
      (function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            var frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
              var w = document.createElement('span'); w.className = 'gp-palabra';
              var s = document.createElement('span'); s.style.setProperty('--i', i++); s.textContent = part;
              w.appendChild(s); frag.appendChild(w);
            });
            n.parentNode.replaceChild(frag, n);
          } else if (n.nodeType === 1 && !n.matches('svg, br')) { walk(n); }
        });
      })(el);
    });
  }

  /* ---------- Revelado al hacer scroll (un único observer) ---------- */
  var io = null;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.gp-reveal, [data-gp-split], [data-gp-observe]');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('gp-visible'); e.dispatchEvent(new CustomEvent('gp:visible')); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('gp-visible');
            en.target.dispatchEvent(new CustomEvent('gp:visible'));
            io.unobserve(en.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (e) { if (!e.classList.contains('gp-visible')) io.observe(e); });
  }

  /* ---------- Parallax suave ---------- */
  var parallaxListo = false;
  function initParallax() {
    if (reduce || parallaxListo) return;
    parallaxListo = true;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      document.querySelectorAll('[data-gp-parallax]').forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var k = parseFloat(el.getAttribute('data-gp-parallax')) || 0;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (p * k * -1).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- Linterna del hero: un halo que sigue al cursor ---------- */
  function initLinterna(root) {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    (root || document).querySelectorAll('[data-gp-linterna]').forEach(function (h) {
      var capa = h.querySelector('.gp-hero__linterna');
      if (!capa) return;
      h.addEventListener('pointermove', function (e) {
        var r = h.getBoundingClientRect();
        capa.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        capa.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      });
    });
  }

  /* ---------- Botones magnéticos ---------- */
  function initMagnetic(root) {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    (root || document).querySelectorAll('[data-gp-magnet]').forEach(function (b) {
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.transform = 'translate(' + (e.clientX - r.left - r.width / 2) * 0.16 + 'px,' + (e.clientY - r.top - r.height / 2) * 0.26 + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }

  /* ---------- Inclinación 3D de tarjetas ---------- */
  function initTilt(root) {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    (root || document).querySelectorAll('[data-gp-tilt]').forEach(function (c) {
      var max = parseFloat(c.getAttribute('data-gp-tilt')) || 6;
      c.addEventListener('mousemove', function (e) {
        var r = c.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
        c.style.transform = 'perspective(900px) rotateY(' + (px * max) + 'deg) rotateX(' + (-py * max) + 'deg) translateY(-4px)';
      });
      c.addEventListener('mouseleave', function () { c.style.transform = ''; });
    });
  }

  /* ---------- Comparador sin / con ---------- */
  function initComparador(root) {
    (root || document).querySelectorAll('[data-gp-comp]').forEach(function (c) {
      var activo = false;
      function mover(x) {
        var r = c.getBoundingClientRect();
        c.style.setProperty('--pos', Math.max(0, Math.min(100, (x - r.left) / r.width * 100)) + '%');
        c.classList.add('is-tocado');
      }
      c.addEventListener('pointerdown', function (e) { activo = true; mover(e.clientX); });
      window.addEventListener('pointerup', function () { activo = false; });
      c.addEventListener('pointermove', function (e) { if (activo || e.pointerType === 'mouse') mover(e.clientX); });
      c.addEventListener('keydown', function (e) {
        var cur = parseFloat(c.style.getPropertyValue('--pos')) || 50;
        if (e.key === 'ArrowLeft') c.style.setProperty('--pos', Math.max(0, cur - 5) + '%');
        if (e.key === 'ArrowRight') c.style.setProperty('--pos', Math.min(100, cur + 5) + '%');
      });
      c.setAttribute('data-gp-observe', '');
      c.addEventListener('gp:visible', function () {
        if (reduce || c.classList.contains('is-tocado')) return;
        var t0 = null;
        function anim(t) {
          if (!t0) t0 = t;
          var p = (t - t0) / 2600;
          if (c.classList.contains('is-tocado')) return;
          if (p >= 1) { c.style.setProperty('--pos', '50%'); return; }
          c.style.setProperty('--pos', (50 + Math.sin(p * Math.PI * 2) * 30) + '%');
          requestAnimationFrame(anim);
        }
        setTimeout(function () { requestAnimationFrame(anim); }, 400);
      });
    });
  }

  /* ---------- Elige su luz ---------- */
  function initColores(root) {
    (root || document).querySelectorAll('[data-gp-colores]').forEach(function (sec) {
      var muestras = sec.querySelectorAll('.gp-muestra');
      var imgs = sec.querySelectorAll('.gp-colores__escena img');
      var nombre = sec.querySelector('.gp-colores__nombre');
      var boton = sec.querySelector('[data-gp-colores-btn]');
      var base = boton ? boton.getAttribute('href') : '';
      var plantilla = boton ? boton.getAttribute('data-plantilla') : '';
      var global = sec.hasAttribute('data-gp-global');
      function elegir(k, guardar) {
        var m = muestras[k]; if (!m) return;
        muestras.forEach(function (x, i) { x.classList.toggle('is-activa', i === k); x.setAttribute('aria-pressed', i === k); });
        imgs.forEach(function (x, i) { x.classList.toggle('is-activa', i === k); });
        var hex = m.getAttribute('data-hex');
        sec.style.setProperty('--gp-luz', hex);
        if (global) ponerLuz(hex, guardar);
        if (nombre) nombre.textContent = m.getAttribute('data-nombre');
        if (boton) {
          var v = m.getAttribute('data-valor');
          boton.setAttribute('href', v && base ? base + (base.indexOf('?') > -1 ? '&' : '?') + 'gp-color=' + encodeURIComponent(v) : base);
          var t = boton.querySelector('.gp-btn__texto');
          if (t && plantilla) t.textContent = plantilla.replace('[color]', m.getAttribute('data-nombre').toLowerCase());
        }
      }
      muestras.forEach(function (m, k) { m.addEventListener('click', function () { elegir(k, true); }); });
      var guardada = ''; try { guardada = localStorage.getItem('gp-luz') || ''; } catch (e) {}
      var ini = 0;
      muestras.forEach(function (m, k) { if (guardada && m.getAttribute('data-hex').toLowerCase() === guardada.toLowerCase()) ini = k; });
      elegir(ini, false);
    });
  }

  /* ---------- Guía de tallas interactiva ---------- */
  function initTallas(root) {
    (root || document).querySelectorAll('[data-gp-tallas]').forEach(function (sec) {
      var rango = sec.querySelector('.gp-tallas__rango');
      var valor = sec.querySelector('[data-gp-cm]');
      var letra = sec.querySelector('[data-gp-talla]');
      var texto = sec.querySelector('[data-gp-talla-texto]');
      var filas = sec.querySelectorAll('tr[data-min]');
      if (!rango) return;
      var tallas = Array.prototype.map.call(filas, function (f) {
        return { fila: f, t: f.getAttribute('data-talla'), min: parseFloat(f.getAttribute('data-min')), max: parseFloat(f.getAttribute('data-max')) };
      });
      function calc() {
        var cm = parseFloat(rango.value);
        var p = (cm - rango.min) / (rango.max - rango.min) * 100;
        rango.style.setProperty('--p', p + '%');
        valor.textContent = cm;
        var cand = tallas.filter(function (t) { return cm >= t.min && cm <= t.max; });
        cand.sort(function (a, b) { return Math.abs(cm - (a.min + a.max) / 2) - Math.abs(cm - (b.min + b.max) / 2); });
        var elegida = cand[0];
        filas.forEach(function (f) { f.classList.toggle('is-activa', !!elegida && f === elegida.fila); });
        if (elegida) {
          letra.textContent = elegida.t;
          texto.textContent = (sec.getAttribute('data-txt-ok') || '').replace('[talla]', elegida.t);
        } else {
          letra.textContent = '?';
          texto.textContent = sec.getAttribute('data-txt-no') || '';
        }
      }
      rango.addEventListener('input', calc);
      calc();
    });
  }

  /* ---------- Acordeones con altura animada ---------- */
  function initAcordeones(root) {
    (root || document).querySelectorAll('.gp-acc').forEach(function (d) {
      if (d.hasAttribute('data-gp-acc-ok')) return;
      d.setAttribute('data-gp-acc-ok', '');
      var s = d.querySelector('summary'), body = d.querySelector('.gp-acc__cuerpo');
      if (!s || !body || reduce) return;
      s.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.open) {
          body.style.height = body.scrollHeight + 'px';
          requestAnimationFrame(function () { body.style.height = '0px'; });
          setTimeout(function () { d.open = false; body.style.height = ''; }, 480);
        } else {
          d.open = true;
          var h = body.scrollHeight; body.style.height = '0px';
          requestAnimationFrame(function () { body.style.height = h + 'px'; });
          setTimeout(function () { body.style.height = ''; }, 520);
        }
      });
    });
  }

  /* ---------- Marquesinas: duplicar contenido para bucle perfecto ---------- */
  function initMarquesinas(root) {
    (root || document).querySelectorAll('[data-gp-marq]').forEach(function (fila) {
      if (fila.hasAttribute('data-gp-marq-ok')) return;
      fila.setAttribute('data-gp-marq-ok', '');
      var pista = fila.querySelector('[data-gp-pista]');
      if (!pista) return;
      var copias = Math.max(1, Math.ceil((window.innerWidth * 1.3) / Math.max(pista.scrollWidth, 1)));
      for (var i = 0; i < copias; i++) { var c = pista.cloneNode(true); c.setAttribute('aria-hidden', 'true'); fila.appendChild(c); }
    });
  }

  /* ---------- Página de producto ---------- */
  function initProducto(root) {
    (root || document).querySelectorAll('[data-gp-pdp]').forEach(function (pdp) {
      // Galería
      var slides = pdp.querySelectorAll('.gp-pdp__slide'), minis = pdp.querySelectorAll('.gp-pdp__mini');
      var idx = 0;
      function ir(i) {
        if (!slides.length) return;
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-activa', k === idx); });
        minis.forEach(function (m, k) { m.classList.toggle('is-activa', k === idx); });
        var mi = minis[idx];
        if (mi && mi.parentElement) {
          var p = mi.parentElement;
          if (p.scrollWidth > p.clientWidth) p.scrollTo({ left: mi.offsetLeft - p.clientWidth / 2 + mi.clientWidth / 2, behavior: 'smooth' });
          else if (p.scrollHeight > p.clientHeight) p.scrollTo({ top: mi.offsetTop - p.clientHeight / 2 + mi.clientHeight / 2, behavior: 'smooth' });
        }
      }
      minis.forEach(function (m, k) { m.addEventListener('click', function () { ir(k); }); });
      var prev = pdp.querySelector('[data-gp-prev]'), next = pdp.querySelector('[data-gp-next]');
      if (prev) prev.addEventListener('click', function () { ir(idx - 1); });
      if (next) next.addEventListener('click', function () { ir(idx + 1); });
      var principal = pdp.querySelector('.gp-pdp__principal');
      if (principal) {
        var x0 = null;
        principal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        principal.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) ir(idx + (dx < 0 ? 1 : -1));
          x0 = null;
        });
      }

      // Cantidad
      var cant = pdp.querySelector('.gp-cant input');
      pdp.querySelectorAll('[data-gp-cant]').forEach(function (b) {
        b.addEventListener('click', function () {
          cant.value = Math.max(1, (parseInt(cant.value, 10) || 1) + parseInt(b.getAttribute('data-gp-cant'), 10));
        });
      });

      // Variantes
      var form = pdp.querySelector('form[action*="/cart/add"]');
      var idInput = form && form.querySelector('input[name="id"]');
      var dataEl = pdp.querySelector('[data-gp-variantes]');
      var variantes = dataEl ? JSON.parse(dataEl.textContent) : [];
      var precioEl = pdp.querySelector('[data-gp-precio]'), tachadoEl = pdp.querySelector('[data-gp-tachado]');
      var ahorroEl = pdp.querySelector('[data-gp-ahorro]');
      var botones = pdp.querySelectorAll('[data-gp-add]');
      var barraPrecio = pdp.querySelector('[data-gp-barra-precio]');
      var formato = pdp.getAttribute('data-money') || '{{amount_with_comma_separator}} €';
      function money(c) {
        var n = (c / 100).toFixed(2);
        return formato.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, n)
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(c / 100)).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100));
      }
      function actualizar(desdeUsuario) {
        var sel = Array.prototype.map.call(pdp.querySelectorAll('[data-gp-opcion]'), function (fs) {
          var c = fs.querySelector('input:checked');
          var et = fs.querySelector('[data-gp-elegido]');
          if (et && c) et.textContent = c.getAttribute('data-etiqueta') || c.value;
          if (c && c.hasAttribute('data-hex') && desdeUsuario) ponerLuz(c.getAttribute('data-hex'), true);
          return c ? c.value : null;
        });
        var v = variantes.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) { botones.forEach(function (b) { b.disabled = true; }); return; }
        idInput.value = v.id;
        if (precioEl) precioEl.textContent = money(v.price);
        if (barraPrecio) barraPrecio.textContent = money(v.price);
        var oferta = v.compare_at_price && v.compare_at_price > v.price;
        if (tachadoEl) tachadoEl.textContent = oferta ? money(v.compare_at_price) : '';
        if (ahorroEl) { ahorroEl.hidden = !oferta; if (oferta) ahorroEl.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
        botones.forEach(function (b) {
          b.disabled = !v.available;
          var t = b.querySelector('.gp-btn__texto');
          if (t) t.textContent = v.available ? b.getAttribute('data-txt-ok') : b.getAttribute('data-txt-agotado');
        });
        if (v.featured_media) {
          var k = Array.prototype.findIndex.call(slides, function (s) { return s.getAttribute('data-media') == v.featured_media.id; });
          if (k > -1) ir(k);
        }
        if (desdeUsuario && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); u.searchParams.delete('gp-color');
          window.history.replaceState({}, '', u.toString());
        }
      }
      pdp.querySelectorAll('[data-gp-opcion] input').forEach(function (i) { i.addEventListener('change', function () { actualizar(true); }); });

      // Llegada desde "Elige su luz" (?gp-color=Green) o con la luz guardada
      var params = new URLSearchParams(window.location.search);
      var pedido = params.get('gp-color');
      var colorInputs = pdp.querySelectorAll('input[data-hex]');
      if (colorInputs.length) {
        var guardada = ''; try { guardada = localStorage.getItem('gp-luz') || ''; } catch (e) {}
        var objetivo = null;
        colorInputs.forEach(function (i) {
          if (pedido && i.value.toLowerCase() === pedido.toLowerCase()) objetivo = i;
        });
        if (!objetivo && !params.get('variant') && guardada) {
          colorInputs.forEach(function (i) { if (i.getAttribute('data-hex').toLowerCase() === guardada.toLowerCase()) objetivo = i; });
        }
        if (objetivo) { objetivo.checked = true; actualizar(true); }
        else { var c = pdp.querySelector('input[data-hex]:checked'); if (c) ponerLuz(c.getAttribute('data-hex'), false); actualizar(false); }
      }

      // Añadir al carrito con el cajón de Dawn (con respaldo de envío normal)
      if (form) form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var aviso = pdp.querySelector('.gp-pdp__aviso');
        botones.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.style.opacity = '.75'; });
        var fd = new FormData(form);
        if (cant) fd.set('quantity', cant.value);
        if (drawer && drawer.getSectionsToRender) {
          fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
          fd.append('sections_url', window.location.pathname);
        }
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res.status) { if (aviso) aviso.textContent = res.description || res.message; return; }
          if (aviso) aviso.textContent = '';
          if (drawer && drawer.renderContents) {
            drawer.renderContents(res);
            if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        }).catch(function () { form.submit(); })
          .finally(function () { botones.forEach(function (b) { b.removeAttribute('aria-busy'); b.style.opacity = ''; }); });
      });

      // Barra fija de compra en móvil
      var barra = pdp.querySelector('.gp-pdp__barra'), compra = pdp.querySelector('.gp-pdp__compra');
      if (barra && compra && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0];
          barra.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(compra);
        var bb = barra.querySelector('[data-gp-barra-btn]');
        if (bb) bb.addEventListener('click', function () {
          var b = form.querySelector('[data-gp-add]');
          if (b && !b.disabled) { if (form.requestSubmit) form.requestSubmit(b); else b.click(); }
        });
      }
    });
  }

  function initTodo(root) {
    initSplit(root); initMarquesinas(root); initComparador(root); initColores(root); initTallas(root);
    initAcordeones(root); initProducto(root); initLinterna(root); initMagnetic(root); initTilt(root); initReveal(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initTodo(document); initParallax(); });
  // Editor de Shopify: re-inicializar al editar una sección
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
